module.exports = __webpack_public_path__ + "static/media/SAINT_6943.8d3c4e9a.jpg";